/* eslint-disable camelcase */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';

import Title from '../shared/Title';
import { FlowHeader, HEADER_HEIGHT } from '../GoalsFlow/styles';
import { breakpoints, palette } from '../../constants/styles';
import Text from '../shared/Text';

import { getCampaign } from '../../constants/utils';
import GetStarted from '../landing/GetStarted';

const StyledTempResult = styled.div`
  padding: 0px 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${HEADER_HEIGHT + 20}px;
  justify-content: flex-start;

  ${breakpoints.tablet} {
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
`;

export const StyledResultTableSavings = styled.tbody`
  & > tr > th {
    padding: 0px;
    border-bottom: none;
  }
  & > tr > * {
    ${({ borderColor }) =>
      borderColor &&
      css`
        border-bottom: 1px solid ${borderColor};
      `}
    padding: 5px;
    text-align: center;

    // Colors
    &:nth-child(1) {
      width: 20px;
      text-align: left;
    }
    // Labels
    &:nth-child(2) {
      width: 50%;
      text-align: left;
    }
    // Money
    &:nth-child(3) {
      width: 30%;
      ${({ borderColor }) =>
        borderColor &&
        css`
          border-left: 1px solid ${borderColor};
        `}
    }
    // Percentage
    &:nth-child(4) {
      width: 20%;
      ${({ borderColor }) =>
        borderColor &&
        css`
          border-left: 1px solid ${borderColor};
        `}
    }
  }
`;

const StyledTempResultContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
`;

class TempResult extends Component {
  state = {};

  render() {
    const { answeredSoFar } = this.props;

    const {
      expensesTotal,
      insurancePayment,
      creditPayment,
      savingsPayment,
      totalIncome,
    } = answeredSoFar;

    // let expensesTotal = 5;
    // let insurancePayment = 0;
    // let creditPayment = 0;
    // let savingsPayment = 0;
    // let totalIncome = 1;

    // if (process.env.REACT_APP_NODE_ENV !== 'development') {
    //   expensesTotal = answeredSoFar.expensesTotal;
    //   insurancePayment = answeredSoFar.insurancePayment;
    //   creditPayment = answeredSoFar.creditPayment;
    //   savingsPayment = answeredSoFar.savingsPayment;
    //   totalIncome = answeredSoFar.totalIncome;
    // }

    return (
      <StyledTempResultContainer>
        <FlowHeader>
          <Title
            level={5}
            color="white"
            styles={css`
              margin-bottom: 0px;
            `}
            medium
          >
            ¡Oops!
          </Title>
        </FlowHeader>
        <StyledTempResult>
          <Title level={4} align="center">
            No logramos cuadrar tus ingresos y egresos.
          </Title>
          <Title level={6} style={{ marginBottom: '1.5em' }} align="center">
            ¿Nos ayudas verificando tu información?
          </Title>
          <Text type="body1" align="left" style={{ alignSelf: 'flex-start' }} medium>
            Tus ingresos y egresos mensuales:
          </Text>
          <table
            cellPadding={0}
            cellSpacing={0}
            style={{ width: '100%', margin: '10px 0px 0px 0px' }}
          >
            <StyledResultTableSavings borderColor={palette.sweetGray}>
              <tr>
                <th />
                <th />
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Ingresos</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color={palette.secondaryColor} align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={totalIncome}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Gastos reportados</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={expensesTotal * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Creditos</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={creditPayment * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Seguros</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={insurancePayment * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1">Ahorro</Text>
                </td>
                <td align="center" style={{ borderBottom: '' }}>
                  <Text type="body1" color="red" align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={savingsPayment * -1}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
              <tr>
                <td align="center" style={{ borderBottom: 'none' }}>
                  <Text type="body1" bold>
                    Total
                  </Text>
                </td>
                <td align="center" style={{ borderBottom: 'none' }}>
                  <Text type="body1" color="red" bold align="right">
                    <NumberFormat
                      style={{ marginRight: '5px' }}
                      value={
                        totalIncome -
                        expensesTotal -
                        creditPayment -
                        insurancePayment -
                        savingsPayment
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      decimalScale={0}
                    />
                  </Text>
                </td>
              </tr>
            </StyledResultTableSavings>
          </table>
          <Text type="body1" style={{ marginTop: '1em' }}>
            El total (
            <NumberFormat
              style={{ color: 'red', fontWeight: '700' }}
              value={
                totalIncome - expensesTotal - creditPayment - insurancePayment - savingsPayment
              }
              displayType="text"
              thousandSeparator
              prefix="$"
              decimalScale={0}
            />
            ) debería ser mayor o igual a <b>$0</b>.
          </Text>
          <GetStarted
            event={`[${getCampaign(window.location.href)}] | Diagnostic | Reiniciar`}
            showFree
            title="Reiniciar formulario"
            to="https://app.finauta.com/plan"
            incentiveColor="white"
          />
        </StyledTempResult>
      </StyledTempResultContainer>
    );
  }
}

export default TempResult;
